import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import BaseLayout from './../../templates/base';
import Loading from './../../elements/loading';
import InmPagination from "../../elements/widgets/inmPagination";
import {confirmAlert} from "react-confirm-alert";
import _ from 'lodash';
import MunicipalityAdd from './../../elements/municipalities/widget/municipality_add';
import MunicipalitySearch from './../../elements/municipalities/widget/municipality_search';

class Municipalities extends Component {
	render(){
		return(
			<MunicipalitiesList {...this.props}/>
		);
	}

	componentWillMount() {
		const { municipalities } = this.props;
		this.props.municipalitiesShow(municipalities.pages.current, municipalities.filters);
	}
}

export class MunicipalitiesList extends Component {
	render(){
		const { municipalities } = this.props;
		let mu = _.find(municipalities.permissions, (o) => {return o==='Update'});
		let md = _.find(municipalities.permissions, (o) => {return o==='Delete'});
		return (
			<div>
				{municipalities.isFetching ? <Loading/>:
					<table className={`inm-table`}>
						<thead>
						<tr>
							<th>ID</th>
							<th>Código</th>
							<th>Nombre</th>
							<th>Estado</th>
							{/*<th>Modalidad</th>*/}
						</tr>
						</thead>
						<tbody>
						{_.map(municipalities.list, (row, k) => {
							return (
								<tr key={k}>
									<td style={{width:10+'%'}}>
										<div className="actions">
											{mu ? <NavLink to={`/municipios/editar/${row.id}`}><i className="fa fa-edit"></i></NavLink>:''}
											{md ? <button onClick={() => this._getConfirm(row.id, row.name)}><i className="fa fa-trash-o"></i></button>:''}
										</div>
										{row.id}
									</td>
									<td>{row.code}</td>
									<td><strong>{row.name}</strong></td>
									<td>{(row.state && row.state.name ? row.state.name:'')}</td>
									{/*<td>{row.modality.name}</td>*/}
								</tr>
							);
						})}
						</tbody>
					</table>}
				{municipalities.pages.total>20 &&
				<InmPagination key="concepts-pages"
				               current={municipalities.pages.current}
				               total={municipalities.pages.total}
				               nextPage={this._handlePageChange}/>}
			</div>
		);
	}

	constructor() {
		super();
		this._handlePageChange = this._handlePageChange.bind(this);
	}

	_getConfirm(id, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar el municipio "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.deleteMunicipality(id)
		})
	}

	_handlePageChange(value) {
		const { municipalities } = this.props;
		this.props.municipalitiesShow(value, municipalities.filters);
	}
}

//export default BaseLayout(Municipalities, {title: `Administrar Municipios`, subnav: {icon: 'fa-map-marker', name: 'Administración', actions: {url: '/municipios/crear', name: 'Agregar Municipio'}}, search:'municipalities'});
export default BaseLayout(Municipalities, {
	title: `Administrar Municipios`,
	subnav: {
		icon: 'fa-map-marker',
		name: 'Administración',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Buscar',
				element: <MunicipalitySearch />
			},
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <MunicipalityAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/municipalities/index.jsx